import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Divider from '@mui/material/Divider';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import { values } from 'lodash';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { SIDEBAR_TYPE as TYPE } from './constants';
import { getSidebarItems } from './helpers';
import SideBarItem from './SideBarItem';
import {
  StyledDrawer,
  StyledListFooter,
  StyledMainList,
  StyledSidebarIcon,
} from './styles';
import Logo from '../logo/Logo';

const Sidebar = ({ open, type, handleToggle, isAdmin, instance, server }) => {
  const { t } = useTranslation();
  const { projectId, instanceId, gpsId, modelId, customInstId, assistantId } =
    useParams();

  const menuItems = getSidebarItems(type, {
    projectId,
    instanceId,
    gpsId,
    modelId,
    customInstId,
    assistantId,
  });

  const ec2Instance = instance || server || null;

  return (
    <StyledDrawer variant="permanent" open={open} aria-label="side-navigation">
      <Logo open={open} />
      <Divider />
      <StyledMainList>
        {menuItems.map((item, index) => (
          <SideBarItem
            key={index}
            type={type}
            open={open}
            item={item}
            isAdmin={isAdmin}
            ec2Instance={ec2Instance}
          />
        ))}
      </StyledMainList>
      <StyledListFooter open={open}>
        <Divider />
        <ListItemButton onClick={handleToggle} aria-label="collapse">
          <StyledSidebarIcon open={open}>
            {open ? <ChevronLeftIcon /> : <ChevronRightIcon />}
          </StyledSidebarIcon>
          <ListItemText primary={t('collapse', { ns: 'project' })} />
        </ListItemButton>
      </StyledListFooter>
    </StyledDrawer>
  );
};

SideBarItem.propTypes = {
  open: PropTypes.bool,
  item: PropTypes.object.isRequired,
  isAdmin: PropTypes.bool,
  ec2Instance: PropTypes.object,
};

Sidebar.propTypes = {
  open: PropTypes.bool,
  type: PropTypes.oneOf(values(TYPE)),
  handleToggle: PropTypes.func.isRequired,
  isAdmin: PropTypes.bool,
  instance: PropTypes.object,
  server: PropTypes.object,
  model: PropTypes.object,
};

export default Sidebar;
